/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description update Location Status Button
 */
import { DeleteOne } from '@icon-park/react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button as AntButton, ButtonProps, Tooltip, App } from 'antd';

import useDeleteLocation from 'hooks/admin/mutate/useDeleteLocation';
import useUpdateLocation from 'hooks/admin/mutate/useUpdateLocation';
import { LOCATION_STATUS } from 'app-constants/admin/location';
import { MODAL_TYPES } from '../modal';
import AccessControl from '../AccessControl';

/**
 * modal content
 */

const getModalContent = (isActiveLocation: boolean, name: string): string | React.ReactNode => {
	return (
		<>
			{isActiveLocation
				? 'You are about to delete this Location. Proceed with caution.'
				: 'Are you sure you want to enable the below Location ?'}
			<br />
			{name}
		</>
	);
};

/**
 * UpdateLocationStatus
 *
 */
const UpdateLocationStatus: React.FC<{ locationDetails: Location.IModel } & ButtonProps> = ({ locationDetails, ...restProps }) => {
	const { modal } = App.useApp();
	const { mutateAsync: updateLocation } = useUpdateLocation();
	const { mutateAsync: deleteLocation } = useDeleteLocation();
	const isActiveLocation = locationDetails.status === LOCATION_STATUS.active.value;
	const activeLocationTooltip = isActiveLocation ? 'Delete Location' : 'Enable Location';
	const editLocation = () => {
		modal.confirm({
			width: 500,
			title: isActiveLocation ? MODAL_TYPES.warning.title : MODAL_TYPES.confirm.title,
			okText: `${isActiveLocation ? 'Delete' : 'Enable'}`,
			content: getModalContent(isActiveLocation, `${locationDetails.name}`),
			onOk: () => {
				if (isActiveLocation) {
					return deleteLocation({ id: locationDetails?.id });
				} else {
					return updateLocation({ id: locationDetails?.id, model: { ...locationDetails, status: LOCATION_STATUS.active.value } });
				}
			},
		});
	};

	return (
		<AccessControl permission='canUpdateLocationStatus'>
			<Tooltip title={activeLocationTooltip}>
				<AntButton
					danger={isActiveLocation}
					type='default'
					icon={isActiveLocation ? <DeleteOne /> : <ReloadOutlined />}
					onClick={editLocation}
					{...restProps}
				/>
			</Tooltip>
		</AccessControl>
	);
};

export default UpdateLocationStatus;
